<app-loading *ngIf="isLoading"></app-loading>
<div class="detail-container">
  <div class="row title-content">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <label>{{ "claimOffice.viewBeneficiary.title" | translate }}</label>
    </div>
  </div>

  <div class="card mt-4 mb-4">
    <dxc-table class="table-responsive-sm dashabordTable p-4 m-4 requireTable">
      <tr class="header-filter">
        <th id="firstName">
          <div class="d-flex">
            {{ "claimOffice.viewBeneficiary.dashboard.firstName" | translate }}
          </div>
        </th>
        <th id="lastName">
          <div class="d-flex">
            {{ "claimOffice.viewBeneficiary.dashboard.lastName" | translate }}
          </div>
        </th>
        <th id="gender">
          <div class="d-flex">
            {{ "claimOffice.viewBeneficiary.dashboard.gender" | translate }}
          </div>
        </th>
        <th id="dateOfBirth">
          <div class="d-flex">
            {{
              "claimOffice.viewBeneficiary.dashboard.dateOfBirth" | translate
            }}
          </div>
        </th>
        <th id="idType">
          <div class="d-flex">
            {{ "claimOffice.viewBeneficiary.dashboard.idType" | translate }}
          </div>
        </th>

        <th id="idNumber">
          <div class="d-flex">
            {{ "claimOffice.viewBeneficiary.dashboard.idNumber" | translate }}
          </div>
        </th>
        <th id="relationship">
          <div class="d-flex">
            {{
              "claimOffice.viewBeneficiary.dashboard.relationship" | translate
            }}
          </div>
        </th>
        <th id="share">
          <div class="d-flex">
            {{ "claimOffice.viewBeneficiary.dashboard.share" | translate }}
          </div>
        </th>
      </tr>
      <ng-container *ngIf="viewBeneficiaryList.length != 0 ">
        <tr
          class="table-header"
          *ngFor="let item of viewBeneficiaryList; index as i"
        >
          <td>
            <span class="mobile-label">
              {{ "claimOffice.viewBeneficiary.dashboard.firstName" | translate }}
            </span>
            <span>{{ item.summary.firstName }} </span>
          </td>

          <td>
            <span class="mobile-label">
              {{ "claimOffice.viewBeneficiary.dashboard.lastName" | translate }}
            </span>
            <span>{{ item.summary.lastName }} </span>
          </td>
          <td>
            <span class="mobile-label">
              {{ "claimOffice.viewBeneficiary.dashboard.gender" | translate }}
            </span>
            <span>{{ getLabelDropdown('Gender', item.summary.genderKey) }}</span>
          </td>
          <td>
            <span class="mobile-label">
              {{
                "claimOffice.viewBeneficiary.dashboard.dateOfBirth" | translate
              }}
            </span>
            <span>{{ dateFormeting(item.summary.dateOfBirth) }} </span>
          </td>

          <td>
            <span class="mobile-label">
              {{ "claimOffice.viewBeneficiary.dashboard.idType" | translate }}
            </span>
            <span>{{ item.summary.idType }} </span>
          </td>

          <td>
            <span class="mobile-label">
              {{ "claimOffice.viewBeneficiary.dashboard.idNumber" | translate }}
            </span>
            <span>{{ item.summary.idNumber }} </span>
          </td>
          <td>
            <span class="mobile-label">
              {{
                "claimOffice.viewBeneficiary.dashboard.relationship" | translate
              }}
            </span>
            <span>{{ item.summary.relationShipTypeCode }} </span>
          </td>
          <td>
            <span class="mobile-label">
              {{ "claimOffice.viewBeneficiary.dashboard.share" | translate }}
            </span>
            <span>{{ item.summary.sharePercentage }} </span>
          </td>
        </tr>
    </ng-container>
    </dxc-table>
    <div class="thereIsNoData" *ngIf="viewBeneficiaryList.length == 0 ">
      <p> {{ "label.common.thereisnodata" | translate }}</p>
    </div>
  </div>

  <div class="text-center">
    <custom-button
      label="{{ 'claimOffice.viewBeneficiary.ok' | translate }}"
      margin="xxsmall"
      mode="primary"
      (onClick)="onOk()"
    >
    </custom-button>
  </div>
</div>
